import React from 'react'
import './headerStyle.scss'
import Home from '../resources/images/home.png'
import { Route, Link } from 'react-router-dom'

const Header = () => (
  <div style={{display: 'block', width: '100%', backgroundColor: '#213b4a'}}>
    <nav>
      <ul id="menu">
        <li className="home"><a href="../"><img src={Home} style={{width: 36, height: 36, verticalAlign: 'middle', marginRight: 10}}/>Corpus Linguistics</a></li>
        <li className="title"><Link to="/">E-C Parallel Concordancer</Link></li>
        {/*<li><Link to="/about">About</Link></li>*/}
        <li><Link to="/info">Corpus Info</Link></li>
        {/*<li><Link to="/contact">Contact Us</Link></li>*/}
        <li><Link to="/search">Search Corpus</Link></li>
        <li className="end"></li>
      </ul>
    </nav>
    <div style={{clear: 'both'}}></div>
  </div>
)

export default Header